import { Injectable } from '@angular/core'
import { CanDeactivate } from '@angular/router'
import Swal from 'sweetalert2'

export interface ComponentCanDeactivate {
  confirm(): boolean
}

@Injectable({
  providedIn: 'root'
})
export class ComponentCanDeactivateGuard implements CanDeactivate<ComponentCanDeactivate> {

  async canDeactivate(
    component: ComponentCanDeactivate
    ): Promise<boolean> {

    var value:boolean = false;
    if (component.confirm()) {
    console.log('Guard can deactivate')
    await Swal.fire({
      title: 'You have unsaved changes!',
      text: "If you leave, your changes will be lost.",
      showCancelButton: true,
      confirmButtonColor: '#800000',
      cancelButtonColor: '#FF2F2F',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        value=true;
      }else{
        value=false;
      }
    })
    return value;
  }else{
    return true;
  }
  }
}
